/**
 * Formate un montant de tokens avec des séparateurs de milliers
 * @param amount - Le montant de tokens à formater
 * @param useSpaces - Si true, utilise des espaces comme séparateurs (français), sinon des virgules (anglais)
 * @returns Le montant formaté avec séparateurs
 *
 * @example
 * formatTokenAmount(25000) // "25 000"
 * formatTokenAmount(1234567) // "1 234 567"
 * formatTokenAmount(500) // "500"
 */
export const formatTokenAmount = (amount: number | undefined, useSpaces: boolean = true): string => {
  if (amount === undefined || amount === null || isNaN(amount)) {
    return '0';
  }

  const separator = useSpaces ? ' ' : ',';

  // Convertir en string et séparer les milliers
  return Math.floor(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

/**
 * Formate un montant de tokens avec signe (+/-) et couleur
 * @param amount - Le montant de tokens (positif = crédit, négatif = débit)
 * @returns Objet avec le texte formaté et la classe de couleur
 */
export const formatTokenChange = (amount: number): { text: string; colorClass: string } => {
  const isPositive = amount > 0;
  const sign = isPositive ? '+' : '-';

  return {
    text: `${sign}${formatTokenAmount(Math.abs(amount))}`,
    colorClass: isPositive ? 'text-mcdm-green-300 dark:text-mcdm-green-300' : 'text-red-600 dark:text-red-400'
  };
};
